import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { validateCPF } from '@gestor-web/@core/utils';

const INVALID_CPF = { cpfInvalid: true };

@Directive({
    selector: '[cpf]',
    providers: [{ provide: NG_VALIDATORS, useExisting: CpfValidator, multi: true }],
    standalone: false
})
export class CpfValidator implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    const cpf = control.value as string;
    return validateCPF(cpf) ? null : INVALID_CPF;
  }
}
